import { useEffect, useState } from 'react';
import { POS_FREQUENT_LIMIT, POS_PAGE_SIZE } from '../../lib/posCatalog';

export const useFrequentLimit = () => {
  const [wide, setWide] = useState(() => window.matchMedia('(min-width: 1024px)').matches);
  useEffect(() => {
    const media = window.matchMedia('(min-width: 1024px)');
    const update = () => setWide(media.matches);
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);
  return wide ? POS_FREQUENT_LIMIT : POS_PAGE_SIZE;
};